export const FILTER_KEYS = {
	STATUS: 'status',
	MIGRATION_PHASE: 'migrationPhase',
} as const;

export const MIGRATION_PHASES = {
	EXPLORE: 'Explore',
	ASSESS: 'Assess',
	PLAN_AND_TRACK: 'Plan & Track',
	TEST_MIGRATION: 'Test Migration',
	PROD_MIGRATION: 'Prod Migration',
	POST_MIGRATION: 'Post-Migration',
} as const;

export type MigrationPhase = (typeof MIGRATION_PHASES)[keyof typeof MIGRATION_PHASES];

export const RUNBOOK_STEP_ACTION_TYPE = {
	STATUS: 'STATUS',
	RISK: 'RISK',
	DISABLE: 'DISABLE',
} as const;

export type RunbookStepActionType =
	(typeof RUNBOOK_STEP_ACTION_TYPE)[keyof typeof RUNBOOK_STEP_ACTION_TYPE];

export type FilterOption<T> = {
	label: string;
	value: T;
};
